<template>
  <v-container fluid pa-5>
    <v-layout row wrap ma-0>
      <v-flex xs12 mb-3>
        <!-- <v-layout row wrap ma-0 class="headline">

        </v-layout>-->
        <p class="title text-left primary--text font-weight-medium">
          แบบรายงานข้อมูลอุบัติเหตุทางถนน - องค์การขนส่งมวลชนกรุงเทพ
        </p>
        <v-divider></v-divider>
      </v-flex>
      <v-flex xs12 layout wrap>
        <v-flex xs12 sm4 pr-sm-2 mt-2>
          <p class="body-2 mb-1">วันที่รายงาน</p>
          <DatePicker ref="reportDate" v-model="reportDate" readonly />
        </v-flex>
        <v-flex xs12 sm4 pr-sm-2 mt-2>
          <p class="body-2 mb-1">ชื่อผู้บันทึก</p>
          <v-text-field
            v-model="reportPerson"
            class="card-border"
            hide-details
            clearable
            my-auto
            solo
            flat
          ></v-text-field>
        </v-flex>
      </v-flex>

      <v-flex xs12 layout wrap>
        <v-flex xs12 sm4 pr-sm-2 mt-2>
          <p class="body-2 mb-1">เขตการเดินรถ</p>
          <v-select
            v-model="busOperationZoneSelect"
            :items="busOperationZoneItems"
            item-text="name"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกเขตการเดินรถ"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
        <v-flex xs12 sm4 pr-sm-2 mt-2>
          <p class="body-2 mb-1">สายการเดินรถ</p>
          <v-select
            v-model="busLinesSelect"
            :items="busLinesItems"
            item-text="name"
            item-value="id"
            no-data-text="ไม่พบข้อมูล"
            label="เลือกสายการเดินรถ"
            class="card-border"
            flat
            solo
            hide-details
          ></v-select>
        </v-flex>
      </v-flex>
      <v-flex xs12 mt-10>
        <!-- 1 -->
        <v-layout row wrap class="ma-0 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">1</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2">วัน-เวลาเกิดเหตุ</p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  วันที่
                  <span class="remark">**</span>
                </p>
                <DatePicker ref="date" v-model="date" />
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  เวลา
                  <span class="remark">**</span>
                </p>
                <TimePicker ref="time" v-model="time" />
              </v-flex>
              <v-flex
                v-show="$vuetify.breakpoint.smAndUp"
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              ></v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">หน่วยงาน</p>
                <v-radio-group v-model="busDepartmentSelect" class="ma-0" hide-details row>
                  <template v-for="(item, index) in busDepartmentItems">
                    <v-radio
                      :key="`road-type-${index}`"
                      color="primary"
                      :label="item.name"
                      :value="item"
                      class="radio-height-40"
                    ></v-radio>
                  </template>
                </v-radio-group>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">ประเภทรถ</p>
                <v-select
                  v-model="busTypeSelect"
                  :items="busTypeItems[busDepartmentSelect.id]"
                  item-text="name"
                  no-data-text="ไม่พบข้อมูล"
                  label="เลือกประเภท"
                  class="card-border"
                  return-object
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">อื่นๆ (ระบุ)</p>
                <v-text-field
                  v-model="busTypeOtherSelect"
                  hide-details
                  class="card-border"
                  clearable
                  my-auto
                  solo
                  flat
                ></v-text-field>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                v-show="busDepartmentSelect != null && busDepartmentSelect.name == 'รถร่วมบริการ'"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  ชื่อผู้ประกอบการ
                </p>
                <v-select
                  :disabled="
                    !busDepartmentSelect || busDepartmentSelect.name == 'รถองค์การขนส่งมวลชนกรุงเทพ'
                  "
                  v-model="companySelect"
                  :items="companyItems[busDepartmentSelect.id]"
                  no-data-text="ไม่พบข้อมูล"
                  item-text="name"
                  class="card-border"
                  placeholder="เลือกบริษัท"
                  return-object
                  flat
                  solo
                  hide-details
                ></v-select>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  'pr-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  ชื่อคนขับ
                  <span class="remark">**</span>
                </p>
                <v-text-field
                  v-model="driversName"
                  hide-details
                  class="card-border"
                  clearable
                  my-auto
                  solo
                  flat
                ></v-text-field>
              </v-flex>
              <v-flex
                :class="{
                  xs6: $vuetify.breakpoint.width >= 400,
                  'pl-1': $vuetify.breakpoint.width >= 400,
                  xs12: $vuetify.breakpoint.width < 400
                }"
                sm4
                mt-2
              >
                <p class="body-2 font-weight-medium mb-0 d-flex align-self-center">
                  หมายเลขทะเบียน
                  <span class="remark">**</span>
                </p>
                <v-row class="mt-0">
                  <v-col class="py-0" cols="4">
                    <v-text-field
                      v-model="headLicense"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      maxlength="3"
                      flat
                    >
                    </v-text-field>
                  </v-col>
                  <v-col class="pt-2" cols="1">
                    <span>-</span>
                  </v-col>
                  <v-col class="py-0">
                    <v-text-field
                      v-model="tailLicense"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      maxlength="4"
                      flat
                    >
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 2 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">2</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                สถานที่เกิดเหตุ
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row" xs12>
            <div
              class="topic-line hidden"
              :class="{ 'line-mobile': $vuetify.breakpoint.xsOnly }"
            ></div>
            <v-flex xs12 pr-1 mt-2 pl-2>
              <v-layout row wrap ma-0>
                <v-flex xs12 mt-2>
                  <p class="body-2 font-weight-medium mb-2">2.1 ประเภทถนน</p>
                </v-flex>
                <v-flex sm12 md4>
                  <v-radio-group v-model="roadType" class="ma-0" hide-details row>
                    <template v-for="(item, index) in roadTypeItems">
                      <v-radio
                        :key="`road-type-${index}`"
                        color="primary"
                        :label="item.name"
                        :value="item.id"
                        class="radio-height-40"
                      ></v-radio>
                    </template>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 layout wrap>
                  <v-flex sm12 md4 mt-2>
                    <p class="body-2 mb-1">
                      จังหวัด
                      <span class="remark">**</span>
                    </p>
                    <v-select
                      v-model="accidentProvinceSelect"
                      :items="provinceItems.filter(el => el.region == 1)"
                      no-data-text="ไม่พบข้อมูล"
                      item-text="name"
                      item-value="id"
                      class="card-border"
                      placeholder="เลือกจังหวัด"
                      flat
                      solo
                      hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex sm12 md4 mt-2 pl-md-2>
                    <p class="body-2 mb-1">
                      ชื่อถนน
                      <span class="remark">**</span>
                    </p>
                    <v-text-field
                      v-model="accidentRoadSelect"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex
                  :class="{
                    xs6: $vuetify.breakpoint.width >= 400,
                    'pr-1': $vuetify.breakpoint.width >= 400,
                    xs12: $vuetify.breakpoint.width < 400
                  }"
                  sm4
                  mt-2
                >
                  <p class="body-2 ma-0">
                    ตำแหน่ง
                    <span class="remark">**</span>
                  </p>
                  <v-radio-group v-model="locationType" class="ma-0" hide-details row>
                    <template v-for="(item, index) in locationTypeItems">
                      <v-radio
                        :key="`location-type-${index}`"
                        color="primary"
                        :label="item"
                        :value="item"
                        class="radio-height-40"
                      ></v-radio>
                    </template>
                  </v-radio-group>
                </v-flex>
                <v-flex v-show="locationType == 'พิกัด'" sm12 md4 mt-2 pr-md-1 pl-md-1>
                  <p class="body-2 ma-0">ละติจูด</p>
                  <v-text-field
                    v-model="latitude"
                    v-on:blur="setMapLocation"
                    v-on:keyup.enter="setMapLocation"
                    hide-details
                    class="card-border"
                    clearable
                    my-auto
                    solo
                    flat
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="locationType == 'พิกัด'" sm12 md4 mt-2 pr-md-1 pl-md-1>
                  <p class="body-2 ma-0">ลองจิจูด</p>
                  <v-text-field
                    v-model="longitude"
                    v-on:blur="setMapLocation"
                    v-on:keyup.enter="setMapLocation"
                    hide-details
                    class="card-border"
                    clearable
                    my-auto
                    solo
                    flat
                  ></v-text-field>
                </v-flex>
                <v-flex v-show="locationType == 'จุดใกล้เคียง'" sm12 md4 mt-2 pr-md-1 pl-md-1>
                  <p class="body-2 ma-0">ชื่อบริเวณ/สถานที่ใกล้เคียง</p>
                  <v-autocomplete
                    v-model="nearbyAreaName"
                    :items="nearbyAreaItems"
                    :search-input.sync="searchNearByAreaItems"
                    class="card-border"
                    no-data-text="ไม่พบข้อมูล"
                    item-text="name"
                    flat
                    solo
                    hide-details
                    clearable
                    return-object
                  ></v-autocomplete>
                </v-flex>
                <v-flex v-show="locationType == 'จุดใกล้เคียง'" sm12 md4 mt-md-10 pl-md-1>
                  <p class="body-2 ma-0 remark">กรุณาเลื่อนแผนที่ไปยังจุดเกิดเหตุ</p>
                </v-flex>
                <v-flex xs12 layout wrap>
                  <v-flex sm12 md4 mt-2 pr-md-1>
                    <p class="body-2 ma-0">ท้องที่เกิดเหตุ</p>
                    <v-text-field
                      v-model="accidentArea"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 md4 mt-2 pr-md-1 pl-md-1>
                    <p class="body-2 ma-0">ชื่อพนักงานสอบสวน</p>
                    <v-text-field
                      v-model="officerName"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12 md4 mt-2 pl-md-1>
                    <p class="body-2 ma-0">อื่นๆ (ระบุ)</p>
                    <v-text-field
                      v-model="areaOtherDescription"
                      hide-details
                      class="card-border"
                      clearable
                      my-auto
                      solo
                      flat
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex xs12 mt-2>
                  <div class="map">
                    <longdo-map :mapOptions="mapOptions" @onload="initMap" />
                  </div>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2">2.2 ลักษณะบริเวณที่เกิดเหตุ</p>
                </v-flex>
                <v-flex xs12 sm10 row wrap ma-0 class="d-flex flex-row">
                  <v-flex xs12>
                    <v-radio-group v-model="surroundSelect" class="ma-0" hide-details>
                      <v-radio
                        v-for="item in surroundItems"
                        :key="item.id"
                        color="primary"
                        :label="item.name"
                        :value="item"
                        :class="{
                          'radio-height-40': $vuetify.breakpoint.width > 800,
                          'input-align-normal': $vuetify.breakpoint.width <= 800,
                          'pb-12': item.id == 2 && $vuetify.breakpoint.xsOnly
                        }"
                      >
                        <template #label v-if="item.needDescription">
                          <v-row>
                            <v-col cols="3" class="py-0">อื่นๆ</v-col>
                            <v-col class="py-0">
                              <v-text-field
                                v-model="otherSurroundDescription"
                                hide-details
                                clearable
                                my-auto
                                solo
                                flat
                                placeholder="ระบุ"
                                class="card-border max-width-200 text-field-as-lebel ml-2"
                              />
                            </v-col>
                          </v-row>
                        </template>
                        <template #label v-else>
                          <div
                            class="d-flex"
                            :class="{
                              'flex-column': $vuetify.breakpoint.width <= 800,
                              'align-start': $vuetify.breakpoint.width > 800
                            }"
                          >
                            {{ item.name }}
                            <v-select
                              v-if="item.id == 2"
                              v-model="crossingSelect"
                              :items="crossingItems"
                              no-data-text="ไม่พบข้อมูล"
                              label="เลือก"
                              class="card-border max-width-200 select-as-lebel"
                              :class="{
                                'mt-2': $vuetify.breakpoint.width <= 800,
                                'ml-2': $vuetify.breakpoint.width > 800
                              }"
                              item-text="name"
                              item-value="id"
                              flat
                              solo
                              hide-details
                              :disabled="surroundSelect.id != 2"
                              @change="railroadCrossingSelect = ''"
                            ></v-select>
                            <v-select
                              v-if="item.id == 2"
                              v-model="railroadCrossingSelect"
                              :items="railroadCrossingItems"
                              no-data-text="ไม่พบข้อมูล"
                              label="เลือก"
                              class="card-border max-width-200 select-as-lebel"
                              :class="{
                                'mt-2': $vuetify.breakpoint.width <= 800,
                                'ml-2': $vuetify.breakpoint.width > 800
                              }"
                              item-text="name"
                              item-value="id"
                              flat
                              solo
                              hide-details
                              v-show="crossingSelect == 6 && railroadCrossingItems.length > 0"
                            ></v-select>
                          </div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2 mt-8">2.3 สภาพดินฟ้าอากาศ</p>
                </v-flex>
                <v-flex xs12 sm10 md7 row wrap ma-0 class="d-flex flex-row">
                  <v-radio-group v-model="weather" class="ma-0" hide-details>
                    <v-row>
                      <v-col class="col-12 col-md-6" v-for="item in weatherItems" :key="item.id">
                        <v-radio
                          v-if="item.needDescription === true"
                          :key="`weather-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                          <template #label>
                            <v-row>
                              <v-col cols="3" class="py-0">
                                {{ item.name }}
                              </v-col>
                              <v-col class="py-0">
                                <v-text-field
                                  v-model="otherWeatherDescription"
                                  hide-details
                                  clearable
                                  my-auto
                                  solo
                                  flat
                                  placeholder="ระบุ"
                                  class="card-border max-width-200 text-field-as-lebel ml-2"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-radio>

                        <v-radio
                          v-else
                          :key="`weather-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2 mt-8">2.4 กลางวัน/กลางคืน</p>
                </v-flex>
                <v-flex xs12 sm10 md7 row wrap ma-0 class="d-flex flex-row">
                  <!-- <v-flex xs12 sm6> -->
                  <v-radio-group v-model="dayOrNight" class="ma-0" hide-details style="width:100%">
                    <v-row>
                      <v-col class="col-12 col-md-6" v-for="item in dayOrNightItems" :key="item.id">
                        <v-radio
                          :key="`dayornight-radio-${item.id}`"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 mt-7>
                  <p class="body-2 font-weight-medium mb-2">
                    2.5 อุปกรณ์หน่วยความปลอดภัยที่ติดตั้งอยู่บริเวณ ณ จุดเกิดเหตุ
                  </p>
                </v-flex>
                <v-flex xs12>
                  <v-layout row wrap ma-0>
                    <v-flex xs12 sm12 md2 class="d-flex align-center">
                      <p class="body-2 mb-0">สัญญาณจราจร :</p>
                    </v-flex>
                    <v-flex xs12 sm12 md10 class="d-flex align-center">
                      <v-radio-group
                        v-model="trafficLight"
                        class="ma-0 ml-5"
                        hide-details
                        :row="$vuetify.breakpoint.mdAndUp"
                      >
                        <template v-for="(item, index) in trafficLightItems">
                          <v-radio
                            :key="`traffic-light-radio-${index}`"
                            color="primary"
                            :label="item.name"
                            :value="item"
                            class="radio-height-40 mr-10"
                            :class="{ 'ml-10': index > 0 && $vuetify.breakpoint.mdAndUp }"
                          ></v-radio>
                        </template>
                      </v-radio-group>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 row wrap ma-0>
                  <v-flex xs12>
                    <v-layout row wrap ma-0>
                      <v-flex xs12 sm12 md2 class="d-flex align-center">
                        <p class="body-2 mb-0">ไฟฟ้าแสงสว่าง :</p>
                      </v-flex>
                      <v-flex xs12 sm12 md10 class="d-flex align-center">
                        <v-radio-group
                          v-model="light"
                          class="ma-0 ml-5"
                          hide-details
                          :row="$vuetify.breakpoint.mdAndUp"
                        >
                          <template v-for="(item, index) in lightItems">
                            <v-radio
                              :key="`traffic-light-radio-${index}`"
                              color="primary"
                              :label="item.name"
                              :value="item"
                              class="radio-height-40 mr-10"
                              :class="{ 'ml-10': index > 0 && $vuetify.breakpoint.mdAndUp }"
                            ></v-radio>
                          </template>
                        </v-radio-group>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
                <v-flex xs12 row wrap ma-0>
                  <v-flex xs12>
                    <v-layout row wrap ma-0>
                      <v-flex xs12 sm12 md2 class="d-flex align-center">
                        <p class="body-2 mb-0">อื่นๆ ระบุ :</p>
                      </v-flex>
                      <v-flex xs12 sm12 md10 class="d-flex align-center">
                        <v-text-field
                          v-model="othersEqipments"
                          hide-details
                          clearable
                          my-auto
                          solo
                          flat
                          placeholder="ระบุ"
                          class="card-border max-width-200 text-field-as-lebel ml-5"
                          :class="{ 'mt-2': $vuetify.breakpoint.smAndDown }"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- 3 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">3</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                คู่กรณี (คนเดินเท้าหรือยานพาหนะที่เกี่ยวข้อง)
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex xs12>
                <VehicleFormDialog
                  ref="vehicleFormDialog"
                  title="เพิ่มหรือแก้ไข"
                  :isAddTrain="true"
                  @getVehicleLists="updateVehicle"
                  :provinceListItem="provinceItems"
                  :vehicleListItem="vehicleItems"
                  :vehicleBrandListItem="vehicleBrandItems"
                  :sexListItem="sexItems"
                  notVehicleId="1"
                />
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 4 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">4</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                จำนวนผู้ได้รับผลกระทบ (แยกผู้ได้รับผลกระทบตามเพศสภาพ)
              </p>
            </div>
          </v-flex>
          <v-flex class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0>
              <v-flex xs12>
                <v-data-table
                  :headers="amountTableHeaders"
                  :items="amountTableItems"
                  :items-per-page="-1"
                  no-data-text="ไม่พบข้อมูล"
                  class="elevation-0 mt-0"
                  hide-default-footer
                  :mobile-breakpoint="0"
                >
                  <template v-slot:item="props">
                    <tr>
                      <td class="text-left no-new-line content-data">{{ props.item.name }}</td>
                      <template v-if="props.item.isPeopleAmount === true">
                        <template v-for="(header, index) in amountTableHeaders">
                          <td
                            v-if="index !== 0"
                            :key="`amount-value-${props.item.model}-${header.value}-${index}`"
                            class="no-new-line content-data px-1 min-width-120"
                          >
                            <v-text-field
                              v-model="amountValue[`${props.item.model}.${header.value}`]"
                              hide-details
                              class="card-border"
                              clearable
                              my-auto
                              solo
                              flat
                              @keypress="onlyNumber($event)"
                            ></v-text-field>
                          </td>
                        </template>
                      </template>
                      <template v-else>
                        <td colspan="2" class="no-new-line content-data px-1 min-width-120">
                          <v-text-field
                            v-model="amountValue[props.item.model]"
                            hide-details
                            class="card-border"
                            clearable
                            my-auto
                            solo
                            flat
                            @keypress="onlyNumber($event)"
                          ></v-text-field>
                        </td>
                      </template>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 5 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">5</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ลักษณะการเกิดอุบัติเหตุ โดยย่อ
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm10 md7 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0 pl-2>
              <template v-for="column in 2">
                <v-flex :key="`accident-character-radio-contianer-${column}`" xs12 sm6>
                  <v-radio-group v-model="accidentCharacter" class="ma-0" hide-details>
                    <template
                      v-for="(item, index) in accidentCharacterItemsSplitColumns[column - 1]"
                    >
                      <template>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-if="item.needDescription === true"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                          <template #label>
                            <v-row>
                              <v-col cols="3" class="py-0">
                                {{ item.name }}
                              </v-col>
                              <v-col class="py-0">
                                <v-text-field
                                  v-model="otherAccidentCharacterDescription"
                                  hide-details
                                  clearable
                                  my-auto
                                  solo
                                  flat
                                  placeholder="ระบุ"
                                  class="card-border max-width-200 text-field-as-lebel ml-2"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-radio>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-else
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </template>
                    </template>
                  </v-radio-group>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 6 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">6</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                มูลเหตุที่สันนิษฐานเบื้องต้น
              </p>
            </div>
          </v-flex>
          <v-flex xs12 sm10 md7 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-layout row wrap ma-0 pl-2>
              <template v-for="column in 2">
                <v-flex :key="`accident-character-radio-contianer-${column}`" xs12 sm6>
                  <v-radio-group v-model="assumed" class="ma-0" hide-details>
                    <template v-for="(item, index) in assumedItemsSplitColumns[column - 1]">
                      <template>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-if="item.descriptionType === 'speed'"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                        </v-radio>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-else-if="item.descriptionType === 'other'"
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        >
                          <template #label>
                            <v-row>
                              <v-col cols="3" class="py-0">
                                {{ item.name }}
                              </v-col>
                              <v-col class="py-0">
                                <v-text-field
                                  v-model="otherAssumedDescription"
                                  hide-details
                                  clearable
                                  my-auto
                                  solo
                                  flat
                                  placeholder="ระบุ"
                                  class="card-border max-width-200 text-field-as-lebel ml-2"
                                />
                              </v-col>
                            </v-row>
                          </template>
                        </v-radio>
                        <v-radio
                          :key="`accident-character-radio-${index}`"
                          v-else
                          color="primary"
                          :label="item.name"
                          :value="item"
                          class="radio-height-40"
                        ></v-radio>
                      </template>
                    </template>
                  </v-radio-group>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- 7 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">7</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                ทรัพย์สินที่เสียหาย
              </p>
            </div>
          </v-flex>
          <v-flex sm12 class="d-flex flex-column ml-8">
            <v-layout v-for="(input, index) in property" row wrap ma-0>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">ระบุ</p>
                <v-text-field
                  v-model="damageAssets[index]"
                  hide-details
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border text-field-as-lebel"
                />
              </v-flex>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">เจ้าของทรัพย์สิน</p>
                <v-text-field
                  v-model="partiesName[index]"
                  hide-details
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border text-field-as-lebel"
                />
              </v-flex>
              <v-flex xs12 sm4 pl-2 pt-4>
                <p class="body-2 mb-1">ที่อยู่</p>
                <v-text-field
                  v-model="address[index]"
                  hide-details
                  clearable
                  my-auto
                  solo
                  flat
                  class="card-border text-field-as-lebel"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <div class="topic-line hidden"></div>
          <v-btn
            rounded
            outlined
            width="120"
            color="primary"
            class="mt-2 ml-2"
            @click="addProperty()"
            >เพิ่มทรัพย์สิน</v-btn
          >
        </v-layout>
        <!-- 8 -->
        <v-layout row wrap class="ma-0 mt-7 d-flex flex-row">
          <v-flex class="d-flex flex-row" xs12>
            <div>
              <div class="topic-number d-flex justify-center align-center white--text">8</div>
            </div>
            <div class="d-flex align-self-center">
              <p class="body-2 font-weight-medium mb-0 ml-2 d-flex align-self-center">
                การดำเนินการ / ขอความช่วยเหลือ
              </p>
            </div>
          </v-flex>
          <v-flex xs12 class="d-flex flex-row">
            <div class="topic-line hidden"></div>
            <v-flex xs12 pl-2 pt-4>
              <v-textarea
                v-model="helpingDescription"
                hide-hint
                :auto-grow="true"
                clearable
                my-auto
                solo
                flat
                class="card-border"
              ></v-textarea>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 mt-10 ml-10 class="updated-user">
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">เบอร์โทรศัพท์</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0">1348</p>
          </v-col>
        </v-row>
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">E-mail</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0" v-if="email">{{ email }}</p>
            <p class="body-2 font-weight-regular mb-0" v-else>-</p>
          </v-col>
        </v-row>
        <v-row class="ma-0" :class="{ 'mb-3': $vuetify.breakpoint.width <= 630 }">
          <v-col :cols="$vuetify.breakpoint.width > 630 ? '5' : '12'" class="text-title pa-0 py-1">
            <p class="body-2 font-weight-bold mb-0">วันที่บันทึก / แก้ไขล่าสุด</p>
          </v-col>
          <v-col
            :cols="$vuetify.breakpoint.width > 630 ? '7' : '12'"
            class="pa-0 py-1"
            :class="{ 'pl-2': $vuetify.breakpoint.width <= 630 }"
          >
            <p class="body-2 font-weight-regular mb-0">{{ currentDateTime }}</p>
          </v-col>
        </v-row>
      </v-flex>
      <v-flex
        class="d-flex flex-column flex-sm-row align-end mt-10 mt-sm-0"
        :class="{ 'height-200': $vuetify.breakpoint.smAndUp }"
      >
        <v-spacer></v-spacer>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          outlined
          width="120"
          color="primary"
          class="mt-2"
          @click="goBacktoReport"
          >ยกเลิก</v-btn
        >
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          rounded
          width="120"
          color="primary"
          class="mt-2 ml-2"
          @click="validateForm"
          >บันทึก</v-btn
        >
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex v-show="false">
        <MapMarker ref="map-marker" />
      </v-flex>
      <v-flex>
        <AlertDialog
          v-model="alertDialog"
          :status="isServiceSuccess ? 'success' : 'error'"
          :cancel-btn="cancelBtn"
          :hide-icon="hideIcon"
          v-on:ok-btn-click="alertDialogOkClicked"
          v-on:cancel-btn-click="alertDialogCancelClicked"
          ><span style="white-space : pre;">{{ alertDialogMessage }}</span></AlertDialog
        >
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import DatePicker from '../global/DatePicker.vue';
import TimePicker from '../global/TimePicker.vue';
import VehicleFormDialog from '../global/VehicleFormDialog.vue';
import AlertDialog from '../global/AlertDialog.vue';
import MapMarker from '../MapMarker.vue';

const qs = require('qs');

export default {
  name: 'Default-Bus',
  components: {
    DatePicker,
    TimePicker,
    VehicleFormDialog,
    MapMarker,
    AlertDialog
  },
  props: {
    accident: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    username: '',
    department: '',
    email: '',
    map: {},
    mapOptions: {
      ui: false,
      zoomRange: {
        max: 18,
        min: 3
      }
    },
    reportDate: '',
    reportPerson: '',
    busOperationZoneSelect: '',
    busOperationZoneItems: [],
    busLinesSelect: '',
    busLinesItems: [],
    provinceItems: [],
    amphoeItems: [],
    tambonItems: [],
    // 1
    date: '',
    time: '',
    busTypeSelect: '',
    busTypeItems: [],
    busDepartmentSelect: '',
    busDepartmentItems: [],
    busTypeOtherSelect: '',
    companySelect: '',
    companyItems: [],
    driversName: '',
    plateLicense: '',
    headLicense: '',
    tailLicense: '',
    // 2.1
    roadType: '',
    roadTypeItems: [],
    locationType: '',
    locationTypeItems: ['พิกัด', 'จุดใกล้เคียง'],
    latitude: '',
    longitude: '',
    accidentProvinceSelect: '',
    accidentRoadSelect: '',
    accidentRoadItems: [],
    trafficLaneAmount: '',
    intersectionSelect: '',
    intersectionItems: [],
    fromIntersectionLength: '',
    nearbyAreaName: '',
    nearbyAreaItems: [],
    searchNearByAreaItems: null,
    accidentArea: '',
    officerName: '',
    areaOtherDescription: '',
    // 2.2
    surroundSelect: '',
    surroundItems: [],
    otherSurroundDescription: '',
    crossingSelect: '',
    crossingItems: [],
    railroadCrossingSelect: '',
    railroadCrossingItems: [],
    // 2.3
    weather: '',
    weatherItems: [],
    otherWeatherDescription: '',
    // 2.4
    dayOrNight: '',
    dayOrNightItems: [],
    // 2.5
    trafficLight: '',
    trafficLightItems: [
      {
        id: 1,
        name: 'มี'
      },
      {
        id: 2,
        name: 'มีแต่ขัดข้อง'
      },
      {
        id: 3,
        name: 'ไม่มี'
      }
    ],
    light: '',
    lightItems: [
      {
        id: 1,
        name: 'มี'
      },
      {
        id: 2,
        name: 'มีแต่ขัดข้อง'
      },
      {
        id: 3,
        name: 'ไม่มี'
      }
    ],
    othersEqipments: '',
    // 3
    // 4
    amountTableHeaders: [
      {
        text: '',
        sortable: false,
        align: 'center',
        value: ''
      },
      {
        text: 'ชาย (คน)',
        sortable: false,
        align: 'center',
        value: 'male'
      },
      { text: 'หญิง (คน)', sortable: false, align: 'center', value: 'female' },
      { text: 'เด็กชาย (คน)', sortable: false, align: 'center', value: 'boy' },
      {
        text: 'เด็กหญิง (คน)',
        sortable: false,
        align: 'center',
        value: 'girl'
      },
      { text: 'ไม่ระบุ (คน)', sortable: false, align: 'center', value: 'null' }
    ],
    amountTableItems: [
      {
        name: 'ผู้เสียชีวิต',
        model: 'dead',
        isPeopleAmount: true
      },
      {
        name: 'ผู้บาดเจ็บสาหัส',
        model: 'hardInjure',
        isPeopleAmount: true
      },
      {
        name: 'ผู้บาดเจ็บเล็กน้อย',
        model: 'softInjure',
        isPeopleAmount: true
      }
    ],
    amountValue: {
      'dead.male': '',
      'dead.female': '',
      'dead.boy': '',
      'dead.girl': '',
      'hardInjure.male': '',
      'hardInjure.female': '',
      'hardInjure.boy': '',
      'hardInjure.girl': '',
      'hardInjure.null': '',
      'softInjure.male': '',
      'softInjure.female': '',
      'softInjure.boy': '',
      'softInjure.girl': '',
      'softInjure.null': ''
    },
    // 5
    accidentCharacter: '',
    accidentCharacterItems: [],
    otherAccidentCharacterDescription: '',
    // 6
    assumed: '',
    assumedItems: [],
    drivingSpeed: '',
    otherAssumedDescription: '',

    // 7
    property: [0],
    damageAssets: [],
    partiesName: [],
    address: [],
    // 8
    helpingDescription: '',
    vehicle: [],
    vehicleItems: [],
    vehicleBrandItems: [],
    sexItems: [],
    // Alert Dialog
    alertDialog: false,
    isServiceSuccess: false,
    cancelBtn: false,
    hideIcon: false,
    alertDialogMessage: '',
    defaultData: ''
  }),
  created() {
    this.username = localStorage.getItem('username');
    this.department = localStorage.getItem('department');
    this.email = localStorage.getItem('email');

    this.getVehicleTypeList();
    this.getVehicleBrandList();
    this.getSexList();
    this.getRoadType();
    // this.getBusDepartmentLists();
    this.getBusZoneLists();
    this.getProvinceLists();
    this.getRoadOption();
  },
  mounted() {},
  methods: {
    validateForm() {
      const errtext = [];
      const field = [
        'date',
        'time',
        'driversName',
        'headLicense',
        'tailLicense',
        'accidentProvinceSelect',
        'accidentRoadSelect',
        'locationType'
      ];
      const text = [
        'วันที่',
        'เวลา',
        'ชื่อคนขับ',
        'หมายเลขทะเบียนส่วนหน้า',
        'หมายเลขทะเบียนส่วนหลัง',
        'จังหวัด',
        'ชื่อถนน',
        'ตำแหน่ง'
      ];
      for (let index = 0; index < field.length; index++) {
        const element = field[index];
        if (!this[element]) errtext.push(`- ${text[index]}`);
      }
      if (errtext.length > 0)
        this.setupAlertDialog(
          true,
          false,
          'validateErr',
          false,
          `กรุณาระบุข้อมูลต่อไปนี้\n${errtext.join('\n')}`
        );
      else this.setupAlertDialog(true, true, 'saveAccident', true, 'ยืนยันการบันทึกข้อมูล ?');
    },
    getRoadOption() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_option`;
      const scope = this;
      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            const { data } = response.data;
            scope.surroundItems = data.surround_character.filter(member => {
              if (member.name === 'อื่นๆ (ระบุ)') member.needDescription = true;
              return member.form_level == 1;
            });
            const crosstrain = {
              id: 2,
              name: 'จุดตัดถนนกับทางรถไฟ'
            };
            scope.surroundItems.splice(2, 0, crosstrain);
            scope.crossingItems = data.surround_character.filter(member => {
              return member.form_level == 2;
            });
            scope.railroadCrossingItems = data.surround_character.filter(member => {
              return member.form_level == 3;
            });
            scope.dayOrNightItems = data.surround_light;
            scope.weatherItems = data.surround_weather;
            scope.weatherItems.forEach(element => {
              if (element.name === 'อื่นๆ') element.needDescription = true;
            });
            scope.accidentCharacterItems = data.accident_pattern;
            scope.accidentCharacterItems.forEach(element => {
              if (element.name === 'อื่น ๆ') element.needDescription = true;
            });
            scope.assumedItems = data.cause_main;
            scope.assumedItems.forEach(element => {
              if (element.name === 'อื่นๆ') element.descriptionType = 'other';
            });
          }
        })
        .catch(function(error) {
          const { response } = error;
          if (response.status === 401) {
            console.log('unauthorized');
            scope.$router.push({ name: 'unauthorized' });
          }
          console.log(error);
        });
    },
    init() {
      this.reportDate = this.utils.getLocalDate();
      this.getBusDepartmentLists();
      this.$refs.reportDate.setDefaultData(this.reportDate);
    },
    initMap(map) {
      this.map = map;
      window.mapdebug = this.map;
      this.map.zoom(18);
      this.map.location({ lat: 13.722237, lon: 100.529561 });
      window.lastLocation = this.map.location();

      this.getMapLayer();

      this.map.Ui.BottomLeft.parentElement.append(this.$refs['map-marker'].$el);
      this.map.Event.bind('location', function() {
        lastLocation = mapdebug.location();
      });
      this.map.Event.bind('zoom', function() {
        if (lastLocation) {
          mapdebug.location(lastLocation, false);
        }
      });
      if (this.accident !== '' && this.accident !== null && this.accident !== undefined) {
        this.getAccidentDetail();
      } else {
        this.init();
      }
    },
    goBacktoReport() {
      this.$router.push({ name: 'report' });
    },
    getMapLayer() {
      const self = this;
      const jsonpAdapter = require('axios-jsonp');

      const baseUrl = 'https://api.nostramap.com/Service/V2/Map/GetPermission?key=';
      const key = `${process.env.VUE_APP_NOSTRA_MAP_KEY}`;

      this.axios({
        url: baseUrl + key,
        adapter: jsonpAdapter
      }).then(response => {
        if (response.status === 200) {
          self.setBaseMap(response.data.results);
        }
      });
    },
    setBaseMap(layer) {
      const base = layer ? layer.filter(x => x.serviceID === '1') : [];
      if (base.length === 1) {
        const nostraSteet = new window.longdo.Layer(false, {
          type: window.longdo.LayerType.ArcGIS_REST,
          url: base[0].serviceURL_L,
          key: base[0].serviceToken_L
        });

        this.map.Layers.setBase(nostraSteet);
      }
    },
    setDefaultObject(Allitem, setitem, field) {
      const item = Allitem.filter(member => {
        return member.id === this.defaultData[field];
      });
      this[setitem] = item[0];
    },
    getsurroundValue() {
      let surroundValue;
      if (this.railroadCrossingSelect) return this.railroadCrossingSelect;
      if (this.crossingSelect) return this.crossingSelect;
      return this.surroundSelect.id;
    },
    getAccidentDetail() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/form/get/accident/${scope.accident}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.defaultData = response.data.data;
            scope.getBusDepartmentLists();
            scope.mapData(response.data.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    mapData(data) {
      const splitReportDate = data.report_date ? data.report_date.split('-') : [];
      if (splitReportDate.length === 3)
        this.$refs.reportDate.setDefaultData(
          `${splitReportDate[2]}-${splitReportDate[1]}-${splitReportDate[0]}`
        ); // วันที่รายงาน
      this.reportPerson = data.reporter_name; // ชื่อผู้บันทึก
      this.busOperationZoneSelect = data.div_code || ''; // เขตการเดินรถ
      this.busLinesSelect = data.subdiv_code || ''; // สายการเดินรถ

      // no.1
      const splitDate = data.accident_date ? data.accident_date.split('-') : [];
      if (splitDate.length === 3)
        this.$refs.date.setDefaultData(`${splitDate[2]}-${splitDate[1]}-${splitDate[0]}`); // วันที่
      this.$refs.time.setDefaultData(data.accident_time); // เวลา

      this.busTypeOtherSelect = data.subcar_type_note; // ประเภทรถอื่นๆ (ระบุ)
      this.driversName = data.driver; // ชื่อคนขับ
      this.headLicense = data.car_no.split('-')[0];
      this.tailLicense = data.car_no.split('-')[1];
      // no.2
      this.roadType = data.road_type_bmta || ''; // ประเภทถนน
      this.accidentProvinceSelect = data.province || ''; // จังหวัด
      this.accidentRoadSelect = data.route_name; // ชื่อถนน
      if (data.latitude && data.longitude) {
        this.locationType = 'พิกัด';
        this.latitude = data.latitude;
        this.longitude = data.longitude;
        this.map.location({ lat: data.latitude, lon: data.longitude });
      } else {
        this.locationType = 'จุดใกล้เคียง';
      }
      this.accidentArea = data.police_station || ''; // ท้องที่เกิดเหตุ
      this.officerName = data.police_name || ''; // ชื่อพนักงานสอบสวน
      this.areaOtherDescription = data.route_note || ''; // สถานที่ อื่นๆ
      const surround = this.surroundItems.filter(
        x => x.id.toString() === data.crash_code.toString()
      );
      if (surround.length) {
        if (surround[0].needDescription) {
          this.otherSurroundDescription = data.crash_name;
        }
        this.surroundSelect = surround[0];
      } else {
        this.surroundSelect = this.surroundItems[2];
        const check = this.crossingItems.find(member => member.id === data.crash_code);
        if (check) {
          this.crossingSelect = data.crash_code;
        } else {
          this.crossingSelect = this.crossingItems.find(member => member.name === 'เครื่องกั้น').id; // hard code
          this.railroadCrossingSelect = data.crash_code;
        }
      }
      const weather = data.weather_code
        ? this.weatherItems.filter(x => x.id.toString() === data.weather_code.toString())
        : [];
      this.weather = weather.length === 1 ? weather[0] : ''; // สภาพดินฟ้าอากาศ
      if (this.weather.needDescription === true) {
        this.otherWeatherDescription = data.weather_name;
      }
      this.dayOrNight = this.dayOrNightItems.filter(member => {
        return member.id.toString() === data.light_code;
      })[0];
      // อุปกรณ์หน่วยความปลอดภัยที่ติดตั้งอยู่บริเวณ ณ จุดเกิดเหตุ
      const trafficLight = data.traffic_light
        ? this.trafficLightItems.filter(x => x.id.toString() === data.traffic_light.toString())
        : [];
      this.trafficLight = trafficLight.length === 1 ? trafficLight[0] : ''; // สัญญาณจราจร
      const light = data.electric_light
        ? this.lightItems.filter(x => x.id.toString() === data.electric_light.toString())
        : [];
      this.light = light.length === 1 ? light[0] : ''; // ไฟฟ้าแสงสว่าง

      this.othersEqipments = data.safety_tool_specify;

      // no.3
      for (let index = 0; index < data.vehicle.length; index++) {
        const element = data.vehicle[index];
        if (element.plate) {
          const carplate = element.plate.split('-');
          data.vehicle[index].plate1 = carplate[0];
          data.vehicle[index].plate2 = carplate[1];
        }
      }
      this.$refs.vehicleFormDialog.setDefaultData(data.vehicle); // คู่กรณี

      // no.4
      // จำนวนผู้ได้รับผลกระทบ
      this.amountValue['dead.male'] = data.dead_male || '';
      this.amountValue['dead.female'] = data.dead_female || '';
      this.amountValue['dead.boy'] = data.dead_boy || '';
      this.amountValue['dead.girl'] = data.dead_girl || '';
      this.amountValue['dead.null'] = data.dead_null || '';
      this.amountValue['hardInjure.male'] = data.serious_injury_male || '';
      this.amountValue['hardInjure.female'] = data.serious_injury_female || '';
      this.amountValue['hardInjure.boy'] = data.serious_injury_boy || '';
      this.amountValue['hardInjure.girl'] = data.serious_injury_girl || '';
      this.amountValue['hardInjure.null'] = data.serious_injury_null || '';
      this.amountValue['softInjure.male'] = data.noneserious_injury_male || '';
      this.amountValue['softInjure.female'] = data.noneserious_injury_female || '';
      this.amountValue['softInjure.boy'] = data.noneserious_injury_boy || '';
      this.amountValue['softInjure.girl'] = data.noneserious_injury_girl || '';
      this.amountValue['softInjure.null'] = data.noneserious_injury_null || '';

      // no.5
      // ลักษณะการเกิดอุบัติเหตุ โดยย่อ
      const accidentCharacter = this.accidentCharacterItems.filter(
        x => x.id.toString() === data.pattern_code.toString()
      );
      this.accidentCharacter = accidentCharacter.length === 1 ? accidentCharacter[0] : '';
      if (this.accidentCharacter.needDescription === true) {
        this.otherAccidentCharacterDescription = data.pattern_name;
      }

      // no.6
      // มูลเหตุที่สันนิษฐานเบื้องต้น
      const assumed = data.cause_code
        ? this.assumedItems.filter(x => x.id.toString() === data.cause_code.toString())
        : [];
      this.assumed = assumed.length === 1 ? assumed[0] : '';
      if (this.assumed.descriptionType === 'other') {
        this.otherAssumedDescription = data.cause_name;
      } else if (this.assumed.descriptionType === 'speed') {
        this.drivingSpeed = data.cause_name;
      }

      // no.7
      // ทรัพย์สินที่เสียหาย
      for (let i = 0; i < data.damage_list.length; i++) {
        this.damageAssets.push(data.damage_list[i].name || ''); // ระบุ
        this.partiesName.push(data.damage_list[i].owner || ''); // เจ้าของทรัพย์สิน
        this.address.push(data.damage_list[i].address || ''); // ที่อยู่
        if (i !== 0) this.property.push(i);
      }

      // no.8
      this.helpingDescription = data.further_name || ''; // การดำเนินการ / ขอความช่วยเหลือ
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.provinceItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getAmphoeLists() {
      if (this.accidentProvinceSelect !== '') return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/amphoe/${this.accidentProvinceSelect}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.amphoeItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.amphoeItems = [];
          console.log(error);
        });
    },
    getVehicleTypeList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_vehicle_type`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    getVehicleBrandList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle_brand`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.vehicleBrandItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.vehicleBrandItems = [];
          console.log(error);
        });
    },
    getSexList() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/casualty_sex`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.sexItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.sexItems = [];
          console.log(error);
        });
    },
    getRoadType() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_road_type`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.roadTypeItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.roadTypeItems = [];
          console.log(error);
        });
    },
    getBusZoneLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/division`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.busOperationZoneItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.busOperationZoneItems = [];
          console.log(error);
        });
    },
    getBusLineLists() {
      if (this.busOperationZoneSelect === '') return;

      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/subdivision/${this.busOperationZoneSelect}`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.busLinesItems = response.data.data;
          }
        })
        .catch(function(error) {
          scope.busLinesItems = [];
          console.log(error);
        });
    },
    getBusDepartmentLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_bus_department`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.busDepartmentItems = response.data.data;
            if (scope.defaultData.car_type) {
              const busDepartment = scope.defaultData.car_type
                ? scope.busDepartmentItems.filter(
                    x => x.id.toString() === scope.defaultData.car_type.toString()
                  )
                : [];
              scope.busDepartmentSelect = busDepartment.length === 1 ? busDepartment[0] : '';
            }
            scope.getBusTypeLists();
            scope.getCompanyList();
          }
        })
        .catch(function(error) {
          scope.busDepartmentItems = [];
          console.log(error);
        });
    },
    getBusTypeLists() {
      const scope = this;
      scope.busDepartmentItems.forEach(function(item, idx) {
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_car_type/${item.id}`;

        scope.axios
          .get(url)
          .then(response => {
            if (response.status === 200 && response.data.data) {
              scope.busTypeItems[parseInt(item.id)] = response.data.data;

              if (
                scope.defaultData.subcar_type_code &&
                scope.defaultData.car_type === item.id.toString()
              ) {
                scope.busTypeSelect = scope.busTypeItems[parseInt(item.id)].filter(member => {
                  return member.id.toString() === scope.defaultData.subcar_type_code.toString();
                })[0];
              }
            }
          })
          .catch(function(error) {
            scope.busTypeItems = [];
            console.log(error);
          });
      });
    },
    getCompanyList() {
      const scope = this;

      this.busDepartmentItems.forEach(function(item, idx) {
        scope.companyItems[item.id] = [];

        if (item.name != 'รถองค์การขนส่งมวลชนกรุงเทพ') {
          const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/bmta_company/${item.id}`;

          scope.axios
            .get(url)
            .then(response => {
              if (response.status === 200 && response.data.data) {
                scope.companyItems[item.id] = response.data.data;
                if (scope.defaultData.company_code) {
                  const company = scope.defaultData.company_code
                    ? scope.companyItems[scope.busDepartmentSelect.id].filter(
                        x => x.id.toString() === scope.defaultData.company_code.toString()
                      )
                    : [];
                  scope.companySelect = company.length === 1 ? company[0] : ''; // ชื่อผู้ประกอบการ
                }
              }
            })
            .catch(function(error) {
              scope.companyItems = [];
              console.log(error);
            });
        }
      });
    },
    numberWithTwoDecimal($event, num) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || num.indexOf('.') !== -1)) {
        // 46 is dot
        $event.preventDefault();
      }

      // restrict to 2 decimal places
      if (num != null && num.indexOf('.') > -1 && num.split('.')[1].length > 1) {
        $event.preventDefault();
      }
    },
    onlyNumber($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57 || keyCode === 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    splitItemsIntoColumns(items) {
      const cols = 2;
      const columns = [];
      const mid = Math.ceil(items.length / cols);
      /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
      for (let col = 0; col < cols; col++) {
        columns.push(items.slice(col * mid, col * mid + mid));
      }
      return columns;
    },
    updateVehicle(value) {
      this.vehicle = value;
    },
    addProperty(value) {
      this.property.push(this.property.length);
    },
    setupAlertDialog(hideIcon, cancelBtn, okBtnCondition, isServiceSuccess, message) {
      this.alertDialog = true;
      this.isServiceSuccess = isServiceSuccess;
      this.cancelBtn = cancelBtn;
      this.hideIcon = hideIcon;
      this.alertDialogMessage = message;
      this.okBtnCondition = okBtnCondition;
    },
    alertDialogOkClicked() {
      this.alertDialog = false;

      switch (this.okBtnCondition) {
        case 'saveAccident':
          this.saveAccident();
          break;
        case 'goToReport':
          this.$router.push({
            name: 'report'
          });
          break;
        default:
          this.alertDialog = false;
      }
    },
    alertDialogCancelClicked() {
      this.alertDialog = false;
    },
    setMapLocation() {
      if (
        this.latitude.length &&
        Number(this.latitude) > -90 &&
        Number(this.latitude) < 90 &&
        this.longitude.length &&
        Number(this.longitude) > -180 &&
        Number(this.longitude) < 180
      ) {
        this.map.location({ lat: this.latitude, lon: this.longitude });
      }
    },
    saveAccident() {
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/form/${
        this.accident !== '' && this.accident !== null && this.accident !== undefined
          ? 'update'
          : 'insert'
      }/bmta`;
      const scope = this;
      const messages = null;

      const damagelist = [];
      // damage_name: this.damageAssets, // ระบุ
      //   opside_name: this.partiesName, // เจ้าของทรัพย์สิน
      //   opside_address: this.address, // ที่อยู่
      for (let index = 0; index < this.damageAssets.length; index++) {
        damagelist.push({
          owner: this.partiesName[index],
          name: this.damageAssets[index],
          address: this.address[index]
        });
      }
      const data = {
        accident_id: this.accident,
        report_date: this.reportDate, // วันที่รายงาน
        reporter_name: this.reportPerson, // ชื่อผู้บันทึก
        div_code: this.busOperationZoneSelect, // เขตการเดินรถ
        subdiv_code: this.busLinesSelect, // สายการเดินรถ

        // no.1
        accident_date: this.date, // วันที่
        accident_time: this.time, // เวลา
        car_type: this.busDepartmentSelect.id, // หน่วยงาน
        subcar_type_code: this.busTypeSelect ? this.busTypeSelect.id : '', // ประเภทรถ
        subcar_type_note: this.busTypeOtherSelect, // ประเภทรถอื่นๆ (ระบุ)
        company_code: this.companySelect ? this.companySelect.id : '', // ชื่อผู้ประกอบการ
        driver: this.driversName, // ชื่อคนขับ
        car_no: `${this.headLicense}-${this.tailLicense}`,

        // no.2
        road_type_bmta: this.roadType, // ประเภทถนน
        province: this.accidentProvinceSelect, // road_type_bmta
        road_name: this.accidentRoadSelect, // ชื่อถนน
        latitude: this.map.location().lat,
        longitude: this.map.location().lon,
        near_place: this.nearbyAreaName.name, // สถานที่ใกล้เคียง
        police_station: this.accidentArea, // ท้องที่เกิดเหตุ
        police_name: this.officerName, // ชื่อพนักงานสอบสวน
        route_note: this.areaOtherDescription, // สถานที่ อื่นๆ
        crash_code: this.getsurroundValue(), // ลักษณะบริเวณที่เกิดเหตุ
        crash_name: this.surroundSelect.name, // ลักษณะบริเวณที่เกิดเหตุ
        weather_code: this.weather.id, // สภาพดินฟ้าอากาศ
        weather_name: this.weather.needDescription
          ? this.otherWeatherDescription
          : this.weather.name, // สภาพดินฟ้าอากาศ
        dayornight_code: this.dayOrNight.id, // กลางวันกลางคืน
        dayornight_name: this.dayOrNight.name, // กลางวันกลางคืน
        // อุปกรณ์หน่วยความปลอดภัยที่ติดตั้งอยู่บริเวณ ณ จุดเกิดเหตุ
        traffic_light: this.trafficLight.id, // สัญญาณจราจร
        electric_light: this.light.id, // ไฟฟ้าแสงสว่าง
        safety_tool_specify: this.othersEqipments,
        // no.3
        vehicle: this.vehicle, // คู่กรณี

        // no.4
        // จำนวนผู้ได้รับผลกระทบ
        dead_male: this.amountValue['dead.male'],
        dead_female: this.amountValue['dead.female'],
        dead_boy: this.amountValue['dead.boy'],
        dead_girl: this.amountValue['dead.girl'],
        dead_null: this.amountValue['dead.null'],
        serious_injury_male: this.amountValue['hardInjure.male'],
        serious_injury_female: this.amountValue['hardInjure.female'],
        serious_injury_boy: this.amountValue['hardInjure.boy'],
        serious_injury_girl: this.amountValue['hardInjure.girl'],
        serious_injury_null: this.amountValue['hardInjure.null'],
        noneserious_injury_male: this.amountValue['softInjure.male'],
        noneserious_injury_female: this.amountValue['softInjure.female'],
        noneserious_injury_boy: this.amountValue['softInjure.boy'],
        noneserious_injury_girl: this.amountValue['softInjure.girl'],
        noneserious_injury_null: this.amountValue['softInjure.null'],

        // no.5
        // ลักษณะการเกิดอุบัติเหตุ โดยย่อ
        pattern_code: this.accidentCharacter.id,
        pattern_name: this.accidentCharacter.needDescription
          ? this.otherAccidentCharacterDescription
          : this.accidentCharacter.name,

        // no.6
        // มูลเหตุที่สันนิษฐานเบื้องต้น
        cause_code: this.assumed.id,
        cause_name: this.assumed.needDescription ? this.otherAssumedDescription : this.assumed.name,

        // no.7
        // ทรัพย์สินที่เสียหาย
        // damage_name: this.damageAssets, // ระบุ
        // opside_name: this.partiesName, // เจ้าของทรัพย์สิน
        // opside_address: this.address, // ที่อยู่
        damage_list: damagelist,

        // no.8
        further_name: this.helpingDescription, // การดำเนินการ / ขอความช่วยเหลือ

        // user
        user_id: localStorage.getItem('user_id') //
      };
      this.axios
        .post(url, qs.stringify(data))
        .then(response => {
          scope.setupAlertDialog(false, false, 'goToReport', true, 'นำข้อมูลเข้าสู่ระบบสำเร็จ');
        })
        .catch(function(error) {
          scope.setupAlertDialog(false, false, 'closeAlert', false, error.response.data.message);
          console.log(error);
        });
    }
  },
  computed: {
    telegraphNoItems() {
      if (this.telegraphNo !== '' && this.telegraphNo !== null) {
        const no = parseInt(this.telegraphNo, 10);
        const items = [];
        items.push(no - 1);
        items.push(no + 1);
        items.push('-');

        return items;
      }
      return [];
    },
    accidentCharacterItemsSplitColumns() {
      return this.splitItemsIntoColumns(this.accidentCharacterItems);
    },
    assumedItemsSplitColumns() {
      return this.splitItemsIntoColumns(this.assumedItems);
    },
    weatherFirstItems() {
      return this.weatherItems.slice(0, this.weatherItems.length / 2);
    },
    weatherLastItems() {
      return this.weatherItems.slice(this.weatherItems.length / 2);
    },
    dayOrNightFirstItems() {
      return this.dayOrNightItems.slice(0, this.dayOrNightItems.length / 2);
    },
    dayOrNightLastItems() {
      return this.dayOrNightItems.slice(this.dayOrNightItems.length / 2);
    },
    currentDateTime() {
      return `${this.utils.formatToDateThai(new Date())} ${this.utils
        .getLocalTime()
        .toISOString()
        .substr(11, 5)} น.`;
    }
  },
  watch: {
    searchNearByAreaItems(val) {
      const scope = this;

      fetch(
        `https://search.longdo.com/mapsearch/json/search?keyword=${val}&key=${process.env.VUE_APP_LONGDO_MAP_KEY}`
      )
        .then(res => res.json())
        .then(res => {
          scope.nearbyAreaItems = res.data || [];
        })
        .catch(err => {
          scope.nearbyAreaItems = [];
          console.log(err);
        });
    },
    busOperationZoneSelect(val) {
      this.getBusLineLists();
    },
    nearbyAreaName(val) {
      this.map.location({ lat: val.lat, lon: val.lon });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0;
  background-color: white;
}

.map {
  max-height: 400px;
  height: 250px;
}

.layout-height-50 {
  height: 50px;
}

.radio-height-40 {
  height: 40px;
}

.height-200 {
  height: 200px;
}

.max-width-200 {
  max-width: 200px;
}

.min-width-120 {
  min-width: 120px;
}

.topic-number {
  width: 32px;
  height: 32px;
  background-color: var(--v-secondary-base);
  border-radius: 50%;
}

.topic-line {
  width: 1px;
  height: 100%;
  margin-left: 15.5px;
  margin-right: 15.5px;
  background-color: var(--v-secondary-base);

  &.line-mobile {
    width: 2px;
  }

  &.hidden {
    visibility: hidden;
  }
}

.damage-title-column {
  flex-grow: 0.5;
}

.form-4 {
  ::v-deep .col {
    max-width: 120px !important;
  }
}

.updated-user {
  ::v-deep .text-title.col {
    max-width: 200px !important;
  }
}

.input-align-normal {
  ::v-deep .v-input--selection-controls__input {
    align-self: normal !important;
  }
}

.select-as-lebel {
  ::v-deep .v-label {
    top: initial !important;
  }
}

.full-width {
  ::v-deep .v-input__control {
    width: 100% !important;
  }
  ::v-deep .v-label {
    width: 100% !important;
  }
}

.remark {
  color: #ff0000;
}

.sm-text-field-in-radio {
  width: 100px;
}

::v-deep .text-field-as-lebel {
  .v-input__slot {
    margin: 0 !important;
  }
}
</style>
